import { render, staticRenderFns } from "./FaceList.vue?vue&type=template&id=655d07f0&scoped=true&"
import script from "./FaceList.vue?vue&type=script&lang=js&"
export * from "./FaceList.vue?vue&type=script&lang=js&"
import style0 from "./FaceList.vue?vue&type=style&index=0&id=655d07f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d07f0",
  null
  
)

export default component.exports